import React from 'react'

export default function Version() {
  return (
    <p>Version 1.0.8</p>
  )
}
